'use strict';

import {
  UtilService
} from './util.service';

export default angular.module('leafApp.util', [])
  .factory('Util', UtilService)
  .name;
